import { CSSObject } from "@emotion/react";
import { type ButtonStyleOverrides, constants } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const popoutButtonListItemCss: CSSObject = {
  button: {
    paddingLeft: "0.5rem",
  },
};

export const buttonCss: ButtonStyleOverrides<CSSObject> = {
  root: {
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    height: "2rem",
    alignItems: "center",
    width: "100%",

    ":hover": {
      background: "#F1F7FF",
    },

    [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
      justifyContent: "space-between",
    },
  },
};

export const chevronLeftCss = {
  root: {
    width: "1.5rem !important",
    height: "1.5rem !important",

    [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
      display: "none",
    },
  },
};

export const menuItemIcon = {
  root: {
    minWidth: "1.5rem",
    width: "1.5rem !important",
    height: "1.5rem !important",
  },
};

export const badgeCss = {
  root: {
    height: "20px !important",
  },
};

export const chevronRightCss = {
  root: {
    width: "1.5rem !important",
    height: "1.5rem !important",
    marginRight: "0.25rem",

    [`@media (min-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
      display: "none",
    },
  },
};

export const openedSubMenuPopoutIndicatorCss: CSSObject = {
  position: "absolute",
  left: "-0.25rem",
  top: 0,
  background: constants.colors.ui.core[700],
  width: "0.25rem",
  height: "2rem",
  borderRadius: "0.13rem",
};
